import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ChatApp from './pages/ChatApp';
import ShareApp from './pages/ShareApp';
import UsageReportPage from './pages/UsageReportPage';
import { AuthProvider } from './auth/AuthContext';
import RequireAuth from './auth/RequireAuth';
import LoginModal from './components/auth/LoginModal';

function App() {
  return (
    <BrowserRouter>
      {/* Auth is app-wide now, not scoped to a gated subtree — the sign-in
          widget in the main header needs to know auth status on every page,
          including anonymous chat. Sign-in itself is a popup (LoginModal),
          not a route, so it's mounted once here alongside the routes. */}
      <AuthProvider>
        <Routes>
          <Route path="/" element={<ChatApp />} />
          <Route path="/share/:shareId" element={<ShareApp />} />
          <Route element={<RequireAuth />}>
            <Route path="/dashboard" element={<UsageReportPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <LoginModal />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
